<template>
  <div :class="['common-dialog-box', className]">
    <div
      tag="div"
      class="dialog-mask"
      @touchmove.prevent
      @click="handleClose({ isMask: 1 })"
    ></div>

    <div :class="['dialog-cont', { 'dialog-box': maskBox }]">
      <span
        :class="['dialog-close', { 'dialog-close-right': rightClose }]"
        @click="handleClose({ isMask: 0 })"
        v-if="showClose || rightClose"
      >
      </span>
      <p class="dialog-tip-title" v-if="tipTitle" v-html="tipTitle"></p>
      <p v-if="title" class="txt" v-html="title">title</p>
      <slot v-else />
      <div class="opt-group">
        <span
          class="btn"
          v-for="(v, index) in buttons"
          :key="index"
          @click="handleClick({ index: index })"
          :style="
            index === buttons.length - 1
              ? {
                  background: theme,
                  color: '#fff',
                  borderColor: theme,
                  ...v.styleData
                }
              : {
                  color: theme,
                  borderColor: theme,
                  ...v.styleData
                }
          "
        >
          {{ v.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// <Dialog
//   title="是否开始接单？"
//   v-if="dialogVisable"
//   :buttons="[{
//     label: '取消'
//   },
//   {
//     label: '确定',
//     onClick: function(){
//       console.log(1)
//     }
//   }]"
//   @close="dialogVisable = false"
// />
const defaultBtns = [
  {
    label: '取消',
    onClick: () => {}
  },
  {
    label: '确定',
    onClick: () => {}
  }
]
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String
    },
    buttons: {
      type: Array,
      default() {
        return defaultBtns
      }
    },
    theme: {
      type: String,
      default: '#ff745b'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: false
    },
    rightClose: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    maskBox: {
      // 有时文案过长会溢出盒子外面，加个参数判断
      type: Boolean,
      default: true
    },
    tipTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick(obj) {
      const { index } = obj
      const close = () => this.$emit('close', this.buttons[index], index)
      let result = true
      //对应button的回调执行
      if (typeof this.buttons[index].onClick === 'function') {
        let _result = this.buttons[index].onClick(close)
        result = _result === false ? false : true
      }
      console.log('result', result)
      if (result) {
        close()
      }
    },
    handleClose({ isMask }) {
      console.log(isMask)
      if (isMask) {
        if (this.maskClose) {
          this.$emit('close')
        }
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '../assets/sass/config';
// @import '../assets/sass/function';
// @import '../assets/sass/mixin';

@import '../../../scss/functions';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.common-dialog-box {
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 12;
  }
  .dialog-cont {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: pxToRem(560);
    padding: pxToRem(80) pxToRem(15) 0;
    background-color: #fff;
    border-radius: pxToRem(30);
    z-index: 12;
    &.dialog-box {
      box-sizing: border-box;
      padding-bottom: pxToRem(50);
    }
    &.move-up {
      animation: moveUpWechat 0.3s ease-out forwards;
    }
    &.move-down {
      animation: moveDownWechat 0.3s ease-out forwards;
    }
    .dialog-close {
      position: absolute;
      right: 50%;
      margin-right: pxToRem(-40);
      bottom: pxToRem(-120);
      color: #c1c1c1;
      display: block;
      background: url('data:image/png;base64,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')
        no-repeat center;
      background-size: cover;
      width: pxToRem(80);
      height: pxToRem(80);
      &.dialog-close-right {
        width: pxToRem(45);
        height: pxToRem(45);
        right: pxToRem(20);
        top: pxToRem(-20);
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAA9dJREFUWAnNmM9rE0EUx2dmS1JFoaL2EIgXK1iLtrlIaZNC0vYgitCLf4F4keJB7B8heBCvXr148QeKh7YJNmn0lipoDwUpLdafRcWfTbM7fl+S2Uy2u8lumpYObHZ25s17n7x5MztvOQtYstnXhzakdZ5xOc4YP4bhES5ZhNRIztZwwyVX8DAd5uJpInHmG/X5Ldyv4Gx2YQKyk0zKhGSsw884KC8xzrOQvTOaGHjgc0xjsfRcYRgAN3ENNZZs3Au4PK6p1EhsvpGkp4eklEY6t3BLSnatkYKgfZyz26n4wHXOuek21hUoUyh0Wb/YfcAgTtpfADUtDrBLyVjsu1P7FiCCMX+yPAR7ncJtfl40DrIhJ5TQjdA0kWd2AYbM9lZmQRo6Qx1QNWZ2ZJp0o6pOIUE21TPd7Smj1WQxltM7d6sOr8TV6rM9REt7twCcdnTbZSDa9HzuMyZn/J9Tofcz/+3dV+sh29WNlykPTda6vWp8QwjeHxadxyGx6CWl2hELd41Ef5cQbEq1NbmXGQS9m+h10ESYou1Hpzj8Lh4/uWZ0hlKQ94QimFRi4EqS8xKXRqGpbhIAA7GIIrMuwGXN301Sdv8xvz7O51f3Jc/2fWShjqQblILBTiyxgvpMZt3zA0QMxEJT5n+ZSzamoMYGT39yesoJY0mWxj/v9gNUlRkXIIsGGADX1qB0T7UBBqpZlDxUPsu0CkWeCnNjmGJGTVMLnlHmI0IdrlSL73vVU0tLS2E6hBHMzNybU9uAwZmPRQRWDzzVWoGC5Z6enqI9OmStI2bW7eegFbBQDH0IOo7k9Zh5/vLtCVp9boEeRDexUAzROThQ0WFoaW9uFnNq9emBHkhpRXgNQDiQByhOGDtmtNXXuqfkisC7acYvjyeMUqBBteQpZCqctuuiND9j/hru1lhF71Px/qha2jjMZXCeOapY6u6czew3jlwcGor+zeReDZqW9aKu3+UBf7YU4kY37ozhTZuGgaSLXK2Jc0twPoHrS8myHjbdgQHFRfgyt4o3LCmv1hS51/BHM0iVUsordyDWGEhKAcWPcIjzVzB90txYDrCnEEPtxDg7V5jH4G3lXv5It0phmvKjI7Fh6qFlXy5o9HtuUUPadtdt20B0pqUkrm1WfCoqJ45aNgu4WqE0CBvds51KEGuWKjVKGJHFnkNA21ms7SESoQ7KKFH1PA1WVLXld5Fs6TCktQ6IGiiTpIyS6Ol5JwrpdstayVbdlOnGq9O3Nz426GB75nOMDkX1PfPByglWfvchO0D7ODZSOo9v+aSHOFhF+3SIiSdBP+n9B3n80X7TOKw8AAAAAElFTkSuQmCC')
          no-repeat center;
        background-size: cover;
      }
    }

    .dialog-tip-title {
      font-size: pxToRem(32);
      color: #21252d;
      font-weight: bold;
      text-align: center;
      margin-bottom: pxToRem(20);
    }

    .txt {
      padding: 0 pxToRem(15);
      // @include font-dpr(14px);
      font-size: pxToRem(30);
      color: #21252d;
      text-align: center;
      line-height: pxToRem(46);
    }
    .opt-group {
      margin-top: pxToRem(60);
      // padding: 0 pxToRem(15);
      display: flex;
      justify-content: space-between;
      .btn {
        margin: 0 pxToRem(15);
        flex: 1;
        height: pxToRem(80);
        line-height: pxToRem(80);
        text-align: center;
        border-radius: pxToRem(80);
        // @include font-dpr(14px);
        font-size: pxToRem(28);
        border-width: 1px;
        border-style: solid;
        box-sizing: border-box;
        // color: #ff745b;

        // &:nth-last-child(1) {
        //   background: #ff745b;
        //   color: #fff;
        // }
      }
    }
  }
}
</style>
